import React, { PureComponent } from 'react'
import { List, ListSubHeader } from 'react-toolbox/lib/list'
import CSSModules from 'helpers/CSSModulesUtil'
import { Card } from 'react-toolbox/lib/card'
import { compose, pure } from 'recompose'
import { ProductHierarchyEnum } from '../constants'
import ListItem from './ListItem'
import styles from './styles.scss'

const PureListItem = pure(ListItem)
const ProductList = () => {
    const keys = Object.keys(ProductHierarchyEnum)
    const list = keys.map((key, index, array) => {
        let parent = ProductHierarchyEnum[key]
        let child = ProductHierarchyEnum[array[index + 1]]
        
        return (
            <Card key={index} theme={styles}>
                <List
                    selectable
                    key={ parent.label }
                    theme={ styles }
                >
                    <ListSubHeader 
                        caption={ parent.label }
                        theme= { styles }
                    />
                    <div>
                        { <PureListItem parent={parent} child={child} /> }
                    </div>
                </List>
            </Card>
        )
    })
    return(
        <React.Fragment>
            {list}
        </React.Fragment>
    )
}

const withStyles = CSSModules(styles)
const enhance = compose(
    withStyles
)
export default enhance(ProductList)